import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { theme } from '../../../db.json';
import { ContainerMenuButtons } from '../../../components/Containers';
import ButtonMainContainer from '../../../components/Home/MainContainer/ButtonMainContainer';
import { SearchLinksSystemsAction } from '../../../redux/actions/linksSystem';

export default function AdminSinc() {
  const themeColors = theme.colors.systems;
  const prefix = '/images/icons/buttons/';
  const { linksSystem: searchLinksSystem } = useSelector((state) => state.searchLinksSystem);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(SearchLinksSystemsAction());
  }, [dispatch]);

  return (
    <ContainerMenuButtons>
      <ButtonMainContainer
        type="button"
        color={themeColors.SC.ApoioAoPrestador}
        name="Sistema de Apoio ao Prestador"
        link={`/sincroniza-nfe`}
        linkImg={`${prefix}logo-sincroniza.png`}
      />
      <ButtonMainContainer
        type="button"
        color={themeColors.SC.ConsultaDeFaturamentos}
        name="Consulta de Faturamentos"
        link={`/sincroniza-nfe/consultar-faturamentos`}
        linkImg={`${prefix}logo-sincroniza-dark.png`}
      />
      <ButtonMainContainer
        type="button"
        color={themeColors.SC.ListaDeTodosQueFaturaram}
        name="Lista simplificada de todos os faturamentos"
        link={`/sincroniza-nfe/consultar-todos-faturamentos`}
        linkImg={`${prefix}list.svg`}
      />
      <ButtonMainContainer
        type="link"
        color={themeColors.SC.SistemaDeGestao}
        name={
          searchLinksSystem &&
          searchLinksSystem.find((link) => link.company === 'Sincroniza' && link.name === 'Sistema de Gestão').name
        }
        link={
          searchLinksSystem &&
          searchLinksSystem.find((link) => link.company === 'Sincroniza' && link.name === 'Sistema de Gestão').url
        }
        linkImg={`${prefix}files.svg`}
        target="_blank"
      />
      <ButtonMainContainer
        type="link"
        color={themeColors.SC.Dashboard}
        name={
          searchLinksSystem &&
          searchLinksSystem.find((link) => link.company === 'Sincroniza' && link.name === 'Dashboard').name
        }
        link={
          searchLinksSystem &&
          searchLinksSystem.find((link) => link.company === 'Sincroniza' && link.name === 'Dashboard').url
        }
        linkImg={`${prefix}file.svg`}
        target="_blank"
      />
    </ContainerMenuButtons>
  );
}
